import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/google.png'


const _hoisted_1 = { class: "testimonial-area si-without-border-radius ptb-100 position-relative z-1" }
const _hoisted_2 = { class: "container-fluid p-md-0 overflow-hidden" }
const _hoisted_3 = { class: "ps-0 list-unstyled d-flex gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "container" }, [
      _createElementVNode("div", {
        class: "section-title mw-1015 m-auto text-center",
        "data-cues": "zoomOut"
      }, [
        _createElementVNode("span", { class: "top-title" }, "آراء عملائنا"),
        _createElementVNode("h2", null, "رضا عملائنا وثقتهم هي سر استمرارنا وتميزنا"),
        _createElementVNode("p", null, " التقييمات تتحدث عن نفسها! عملائنا يعشقون ثبات البث وجودة السيرفرات تماماً كما نحرص نحن عليها. ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        spaceBetween: 50,
        loop: true,
        centeredSlides: true,
        preventClicks: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 4,
          },
          1600: {
            slidesPerView: 4.5,
          },
        },
        modules: _ctx.modules,
        class: "testomonial-slide"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial, index) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(['testimonial-single-item', testimonial.styleClass])
                }, [
                  _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                      return _createElementVNode("li", { key: star }, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("i", { class: "ri-star-fill" }, null, -1)
                      ]))])
                    }), 64))
                  ]),
                  _createElementVNode("h3", null, _toDisplayString(testimonial.name), 1),
                  _createElementVNode("p", null, _toDisplayString(testimonial.message), 1)
                ], 2)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"]),
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center google-review flex-wrap\" data-cues=\"zoomOut\"><div class=\"d-flex align-items-center\"><img src=\"" + _imports_0 + "\" alt=\"google\"><p>التقييم العام <span>4.9</span></p></div><a href=\"https://wa.me/447429916178\" target=\"_blank\" class=\"read-more text-grey-teal\"><span>اشترك وتواصل معنا الآن</span><i class=\"ti ti-arrow-right\"></i></a></div>", 1))
    ])
  ]))
}